// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import queryString from 'query-string';

const getSceneHref = ({ title, frames, annotations, showImages, showProjectedPoints }) => {
  const search = queryString.stringify({
    title,
    frames: frames.join(','),
    annotations,
    showImages,
    showProjectedPoints,
  });
  return `https://lidar-now.scale.com/embed?${search}`;
};

export default class LidarTaskPreview extends React.Component {
  constructor() {
    super();

    this.state = {
      showEmbed: false,
    };
  }

  handleToggleShowEmbed = () => {
    this.setState({
      showEmbed: !this.state.showEmbed,
    });
  };

  render() {
    const { object, response } = this.props;
    const annotations = _.get(response, 'annotations.url', undefined);
    const allFrames = _.get(object, 'params.attachments', []);
    const frames = allFrames.slice(0, 10);

    const sceneHref = getSceneHref({
      frames,
      annotations,
      title: `${object.__t === 'task' ? 'Task' : 'Subtask'} ${object.id}`,
      showImages: true,
      showProjectedPoints: true,
    });
    const aStyle = {
      display: 'block',
      textDecoration: 'none',
    };

    return (
      <div>
        <div>
          Showing {frames.length} / {allFrames.length} frames
        </div>
        <div>
          {' '}
          <a href={sceneHref}>Open in Lidar Viewer</a>
        </div>
        <div>
          {' '}
          <a style={aStyle} onClick={this.handleToggleShowEmbed}>
            {this.state.showEmbed ? 'Hide Embed' : 'Show Embed'}
          </a>
        </div>
        <br />
        {this.state.showEmbed && (
          <iframe
            title="lidar"
            width="1000"
            height="500"
            src={sceneHref}
            allowFullScreen
            frameBorder="0"
          >
            {' '}
          </iframe>
        )}
      </div>
    );
  }
}
